import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import AddInputs from "../../components/Add/AddInputs";
import S3ImageUpload from "../../components/S3uploads/S3ImageUpload";
import AddModel from "../../components/Add/AddModel";
import AddBottomButton from "../../components/Add/AddBottomButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import {
  fetchAdminView,
  removeAdminFieldError,
  resetAddAdmin,
  setAccessPrivilege,
  setAddAdminError,
  setAddAdminFelidError,
  setAddAdminLoader,
  setAddLoading,
  setIsVerifiedFirst,
  setSelectAllAccessPrivilege,
  setUpdateAdminStates,
} from "./addAdminSlice";
import {
  resetPhoneNumbers,
  setPhoneNumber,
  setVerifiedSecondaryPhoneNumbers,
  setErrorById,
  setDuplicateErrorById,
  setLoadingStateById,
  setIsVerifiedById,
} from "../../store/slices/phoneNumbersSlice";
import { useEffect, useState } from "react";
import {
  setInstructionText,
  setIsOpenModel,
} from "../../store/slices/modelSlice";
import useApi from "../../services/useApi";
import { showToast } from "../../components/toastMessage/toastSlice";
import endpoints from "../../services/endpoints";
import { formEmptyValidation } from "../../components/commonfunctions/formEmptyValidation";
import { setErrorMessage, setOtp, resetOtp } from "../auth/otpSlice";
import { setLoading } from "../auth/loginSlice";
import AccessPrivilege from "../../components/Add/AccessPrivilage/AccessPrivilege";
import CheckBoxWithTitle from "../../components/checkbox/CheckBoxWithTitle";
import { access } from "../../components/utils/access";
import { transformString } from "../../components/commonfunctions/transformString";
import deepEqual from "../../components/commonfunctions/deepEqual";
import { inputFieldContent } from "../../components/inputfields/InputFieldContent";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { getTotalPrivilegesCount } from "../../components/utils/access";

export default function AddAdmin() {
  const dispatch = useDispatch<AppDispatch>();
  const {
    addAdminDetails,
    felidError,
    errors,
    add_loading,
    addAdminLoader,
    accessPrivilege,
    wallet_access,
    editLoading,
    editData,
    accessPrivilegeEdit,
    disableAll,
    wallet_access_edit,
    isVerifiedFirst
  } = useSelector((state: RootState) => state.addAdmin);
  const { otp } = useSelector((state: RootState) => state.otp);
  const { phoneNumbers } = useSelector((state: RootState) => state.phoneNumbers);
  const [isOpenOtpModel, setIsOpenOtpModel] = useState(false);
  const [currentPhone, setCurrentPhone] = useState('');
  const { selectedOTPid } = useSelector((state: RootState) => state.model);
  const pathUrl = useSelector((state: RootState) => state.geolocation.previousUrl);
  const navigation = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  const { otpVerify, otpSend } = endpoints;
  const {
    first_name,
    email_address,
    phone_number,
    country,
    province,
    district,
    postal_code,
    city_town,
    house_no,
    market_block_no,
    floor_no,
    street_name,
    region,
    sop_file,
    last_name,
    email_address_verify,
    phone_number_verify,
    country_code,
    is_super_admin
  } = addAdminDetails;
  const { PostAPI, PatchAPI } = useApi();
  const { translate, replace } = useTranslation(inputFieldContent);
  const inputs = {
    "Personal Details": {
      "First Name": {
        required: true,
        disabled: false,
        id: "first_name",
        maxLength: 60,
        type: "input",
        tabIndex: 0,
      },
      "Last Name": {
        required: false,
        disabled: false,
        maxLength: 60,
        id: "last_name",
        type: "input",
        tabIndex: 1,
      },
      "Official Email Address": {
        required: true,
        disabled: !first_name,
        id: "email_address",
        maxLength: 90,
        type: "input_verification",
        tabIndex: 2,
      },
      "Phone Number": {
        required: true,
        disabled: !first_name,
        id: "phone_number",
        type: "phone_number",
        maxLength: 15,
        tabIndex: 3,
      },
      multiPhoneNumber: {
        required: false,
        disabled: !first_name,
        id: "multiPhoneNumber",
        type: "multiPhoneNumber",
        tabIndex: 4,
        maxLength: 15,
      },
    },
    "Residential Details": {
      "House No.": {
        required: false,
        disabled: false,
        id: "house_no",
        type: "input",
        maxLength: 60,
        tabIndex: 4,
      },
      "Market/Block No.": {
        required: false,
        disabled: false,
        id: "market_block_no",
        type: "input",
        maxLength: 60,
        tabIndex: 5,
      },
      "Floor No.": {
        required: false,
        disabled: false,
        id: "floor_no",
        type: "input",
        tabIndex: 6,
        maxLength: 60,
      },
      "Street Name": {
        required: false,
        disabled: false,
        id: "street_name",
        type: "input",
        tabIndex: 7,
      },
      Country: {
        required: false,
        disabled: false,
        id: "country",
        type: "country_type",
        tabIndex: 9,
      },
    },
  };
 
  const handleInputValues = (key: string, value: string) => {
    // Check if the input field is 'first_name' or 'last_name'
    if (key === 'first_name' || key === 'last_name') {
      // If it's 'first_name' or 'last_name', update the corresponding state
      const regex = /^[A-Za-z\s]*$/;
      // If the value contains numbers and special characters, stop execution and return
      if (!regex.test(value)) {
        return;
      }
    }
    dispatch(setUpdateAdminStates({ key, value }));
    switch (key) {
      case "phone_number":
        dispatch(removeAdminFieldError('phone_number'))
        dispatch(
          setUpdateAdminStates({ key: "phone_number_verify", value: id ? (editData.phone_number === value && isVerifiedFirst) ? 'true' : "" : "" })
        );
        break;
      case "email_address":
        dispatch(
          setUpdateAdminStates({
            key: "email_address_verify",
            value: "",
          })
        );
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    dispatch(setAddLoading(true));
    try {
      const mandatoryField: any = {
        first_name,
        email_address,
        phone_number,
        country,
      };
      if (country.toLowerCase() === "afghanistan") {
        mandatoryField.province = province;
        if (province) mandatoryField.district = district;
        if (district)  mandatoryField.city_town = city_town;
      } else {
        mandatoryField.province = province;
        mandatoryField.postal_code = postal_code;
      }

      const emptyFieldErrors = formEmptyValidation(mandatoryField);
      if (Object.keys(emptyFieldErrors).length > 0) {
        dispatch(setAddAdminError(emptyFieldErrors));
        return;
      }
      if (!email_address_verify || !phone_number_verify) {
        const errors: Record<string, string> = {};
        if (!email_address_verify)
          errors.email_address = "Please verify your email address";
        if (!phone_number_verify)
          errors.phone_number = "Please verify your phone number";
        dispatch(setAddAdminError(errors));
        return;
      }

      if (validatePhoneNumbers()) return;
      if (!is_super_admin && accessPrivilege.length === 0) {
        dispatch(
          setAddAdminError({
            access_privilege: "At least 1 selection is required",
          })
        );
        return;
      }

      const result = Object.values(access).flatMap((section) =>
        Object.entries(section).map(([action, id]) => ({ [action]: id }))
      );

      const privilegeArray: string[] = [];

      accessPrivilege.forEach((accessPrivilegeItem) => {
        result.forEach((resultItem) => {
          const action = Object.keys(resultItem)[0];
          if (action === accessPrivilegeItem) {
            privilegeArray.push(resultItem[action]);
          }
        });
      });

      const walletAccess =
        wallet_access.length === 0
          ? undefined
          : wallet_access.map((item) => {
            return transformString(item).toLocaleLowerCase();
          });

      const verifiedSecondaryPhones = phoneNumbers
        .filter((phone) => phone.isVerified === 'true' && phone.value.length > 6)
        .map((phone) => ({
          country_code: `+${phone.countryCode}`,
          phone_number: phone.value.replace(`${phone.countryCode}`, ''),
        }));

      const payload: any = {
        first_name: (id && editData.first_name === first_name) ? undefined : first_name.trim(),
        last_name: (id && editData.last_name === last_name) ? undefined : last_name?.trim() || undefined,
        phone_number: (id && editData.phone_number === phone_number) ? undefined : `${phone_number.trim().replace(country_code, '')}`,
        email_address: (id && editData.email_address === email_address) ? undefined : email_address?.trim(),
        country: (id && editData.country === country) ? undefined : country?.trim(),
        city_town: (id && editData.city_town === city_town) ? undefined : city_town?.trim() || undefined,
        house_no: (id && editData.house_no === house_no) ? undefined : house_no?.trim() || undefined,
        market_block_no: (id && editData.market_block_no === market_block_no) ? undefined : market_block_no?.trim() || undefined,
        floor_no: (id && editData.floor_no === floor_no) ? undefined : floor_no?.trim() || undefined,
        street_name: (id && editData.street_name === street_name) ? undefined : street_name?.trim() || undefined,
        province: (id && editData.province === province) ? undefined : province?.trim(),
        region: (id && editData.region === region) ? undefined : region?.trim() || undefined,
        district: (id && editData.district === district) ? undefined : district?.trim() || undefined,
        postal_code: (id && editData.postal_code === postal_code) ? undefined : postal_code?.trim() || undefined,
        sop_file: (id && editData.sop_file === sop_file) ? undefined : sop_file,
        wallet_access: (id && accessPrivilegeEdit === walletAccess) ? undefined : walletAccess || [],
        country_code: (id && editData.country_code === country_code) ? undefined : `+${country_code.trim()}`,
        secondary_phone_numbers: verifiedSecondaryPhones,
      };

      if (id) {
        if (!is_super_admin) {
          payload.access_privileges = (accessPrivilegeEdit === accessPrivilege) ? undefined : privilegeArray;
          if (payload.access_privileges !== undefined) {
            payload.is_super_admin = false;
          }
        }else {
          payload.is_super_admin = true;
        }
      } else if (!is_super_admin) {
        payload.access_privileges = privilegeArray;
        payload.is_super_admin = false;
      } else if (is_super_admin) {
        payload.is_super_admin = true;
      }

      let res = {
        error: false,
        data: {
          message: '',
          response: {
            data: {
              field: '',
              message: ''
            }
          }
        }
      }
      res = id ? await PatchAPI(`admins/${id}`, payload) : await PostAPI("admins", payload);

      if (!res.error) {
        dispatch(
          showToast({
            type: "success",
            message: id ? translate('Admin details updated successfully') : translate(res.data.message),
          })
        );
        navigation(pathUrl ? pathUrl : "/admin-management/list-of-admins");
      } else if (res.data.message === translate("Request failed with status code 409")) {
        dispatch(
          setAddAdminError({
            [res.data.response.data.field]: translate(res.data.response.data.message),
          })
        );
      } else {
        dispatch(
          showToast({
            type: "error",
            message: res.data.message,
          })
        );
      }
    } catch (error: unknown) {
      console.error(translate("Error during admin creation:"), error);
    } finally {
      dispatch(setAddLoading(false));
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchAdminView(`admins/${id}?edit_mode=true`)).then((action: any) => {
        const data = action?.payload?.data;
        if (data && !action.payload.error) {
          if (data.secondary_phone_numbers?.length > 0) {
            const formatted = data.secondary_phone_numbers.map((phone: any, index: number) => ({
              id: (index + 1).toString(),
              value: phone.country_code.split('+')[1] + phone.phone_number,
              isVerified: 'true',
              countryCode: phone.country_code.split('+')[1],
              loading: false,
              error: '',
            }));
            dispatch(setPhoneNumber(formatted));
            formatted.forEach((phone: any) => {
              dispatch(setVerifiedSecondaryPhoneNumbers({ id: Number(phone.id) - 1, value: '+' + phone.value }));
            });
          } else {
            dispatch(resetPhoneNumbers());
          }
        }
      });
    } else {
      dispatch(resetAddAdmin());
      dispatch(resetPhoneNumbers());
    }
  }, []);

  const checkForDuplicatePhoneNumbers = (keyToCheck: string, fieldId?: string): boolean => {
    const primaryNumber = { value: phone_number, isVerified: phone_number_verify };
    const allPhoneNumbers = [...phoneNumbers, primaryNumber];
    for (const phone of allPhoneNumbers) {
      if (phone.value === keyToCheck.replace('+', '') && phone.isVerified) {
        dispatch(showToast({ type: 'error', message: 'Phone numbers must be unique.' }));
        if (fieldId) {
          dispatch(setDuplicateErrorById({ id: fieldId, duplicateError: true }));
        }
        return true;
      }
    }
    return false;
  };

  const validatePhoneNumbers = (): boolean => {
    let isAnyNotVerified = false;
    phoneNumbers.forEach((phone) => {
      if (phone.isVerified !== 'true' && phone.value.length > 6) {
        dispatch(setErrorById({ id: phone.id, error: 'Please verify your secondary phone number' }));
        isAnyNotVerified = true;
      } else {
        dispatch(setErrorById({ id: phone.id, error: '' }));
      }
    });
    return isAnyNotVerified;
  };

  const handleVerify = async (id: string, resend: boolean, type?: string, idNumber?: string) => {
    let phoneNumber = `+${phone_number}`;
    let countryCodeForDisplay = `+${country_code}`;

    if (type === 'secondary_phone_number') {
      dispatch(setErrorById({ id: idNumber || '', error: '' }));
      phoneNumbers.forEach((item) => {
        if (item.id === idNumber) {
          phoneNumber = `+${item.value}`;
          id = 'phone_number';
          countryCodeForDisplay = `+${item.countryCode}`;
        }
      });
    }

    const errors: Record<string, string> = {};
    if (id === "phone_number") errors.phone_number = "";
    if (id === "email_address") errors.email_address = "";
    dispatch(setAddAdminError(errors));

    if (id === 'phone_number') {
      const phoneDigits = phoneNumber.replace(countryCodeForDisplay, '');
      if (phoneDigits.length < 7 || phoneDigits.length > 10) {
        dispatch(showToast({ type: 'error', message: 'Phone number must be between 7 and 10 digits' }));
        return;
      }
    }

    if (id === 'phone_number' && checkForDuplicatePhoneNumbers(phoneNumber, type === 'secondary_phone_number' ? idNumber : undefined)) return;

    try {
      if (type === 'secondary_phone_number') {
        dispatch(setLoadingStateById({ id: idNumber || '', loading: true }));
      } else {
        dispatch(setAddAdminLoader({ key: id, value: true }));
      }

      const payload =
        id === "phone_number"
          ? { phone_number: phoneNumber, name: first_name }
          : { email_address: `${email_address}`, name: first_name };

      const response = await PostAPI(otpSend, payload);
      if (!response.error) {
        dispatch(resetOtp());
        if (id === 'phone_number') setCurrentPhone(phoneNumber);
        setIsOpenOtpModel(true);
        dispatch(
          showToast({
            type: "info",
            message: resend
              ? "OTP resent"
              : replace(`OTP has been sent to {{phone_or_email}}`, {
                  phone_or_email:
                    id === "phone_number"
                      ? `${countryCodeForDisplay} ${phoneNumber.replace(countryCodeForDisplay, '')}`
                      : email_address,
                }),
          })
        );
        dispatch(setIsOpenModel(true));
        dispatch(
          setInstructionText({
            text: replace(`We have sent a code to {{phone_or_email}}`, {
              phone_or_email:
                id === "phone_number"
                  ? `${countryCodeForDisplay} ${phoneNumber.replace(countryCodeForDisplay, '')}`
                  : email_address,
            }),
            id,
          })
        );
      } else {
        dispatch(setAddAdminFelidError(id));
        dispatch(showToast({ type: "error", message: response?.data?.response?.data?.message }));
      }
    } catch (error: unknown) {
      dispatch(setAddAdminFelidError(id));
      console.error("Error sending OTP:", error);
      dispatch(showToast({ type: "error", message: "Failed to send OTP. Please try again." }));
    } finally {
      if (type === 'secondary_phone_number') {
        dispatch(setLoadingStateById({ id: idNumber || '', loading: false }));
      } else {
        dispatch(setAddAdminLoader({ key: id, value: false }));
      }
    }
  };
  const handleSubmitOTP = async (key?: string) => {
    dispatch(setLoading(true));
    const payload =
      selectedOTPid === "phone_number" || key
        ? { phone_number: key ? currentPhone : `+${phone_number}`, otp: otp.join("") }
        : { email_address: email_address, otp: otp.join("") };

    try {
      const res = await PostAPI(otpVerify, payload);
      if (!res.error) {
        if (key) {
          dispatch(setIsVerifiedById({ id: key, isVerified: 'true' }));
          dispatch(setVerifiedSecondaryPhoneNumbers({ id: Number(key) - 1, value: currentPhone }));
        } else {
          handleInputValues(
            selectedOTPid === "phone_number" ? "phone_number_verify" : "email_address_verify",
            "true"
          );
        }
        setIsOpenOtpModel(false);
        dispatch(setOtp({ otp: [] }));
        dispatch(setIsVerifiedFirst(false));
      } else {
        dispatch(setErrorMessage(res.data.response.data.message || "Invalid OTP."));
      }
    } catch (error: unknown) {
      console.error("Error verifying OTP:", error);
      dispatch(setErrorMessage("Invalid OTP. Please try again."));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handelCheckBox = (id: string) => {
    dispatch(setAddAdminError({ access_privilege: "" }));
    dispatch(setAccessPrivilege(id));
  };

  const handelAllAccessPrivilege = () => {
    dispatch(setAddAdminError({ access_privilege: "" }));
    const willBeAllSelected = accessPrivilege.length !== getTotalPrivilegesCount();
    dispatch(setSelectAllAccessPrivilege(willBeAllSelected));
  };

  const currentSecondaryPhones = phoneNumbers
    .filter((phone) => phone.isVerified === 'true' && phone.value.length > 6)
    .map((phone) => ({
      country_code: `+${phone.countryCode}`,
      phone_number: phone.value.replace(`${phone.countryCode}`, ''),
    }));

  const hasUnverifiedSecondaryPhone = phoneNumbers.some(
    (p) => p.value.length > 6 && p.isVerified !== 'true'
  );

  const hasSecondaryPhoneChanges = id
    ? !deepEqual(editData.secondary_phone_numbers || [], currentSecondaryPhones)
    : false;

  return (
    <div className="">
      <Breadcrumbs
        navPath={[
          "Admin Management",
          pathname.includes('/view-admin-profile') ? 'View Admin Profile' : "List of Admins",
          `${`${id ? "Edit" : "Add"} Admin`}`,
        ]}
        heading={`${id ? "Edit" : "Add"} Admin`}
        links={(pathUrl && id) ? [pathUrl, pathUrl] : [
          id ? 'back' : "/admin-management/list-of-admins",
          id ? 'back' : "/admin-management/list-of-admins",
        ]}
      />
      <AddModel>
        <AddInputs
          editLoading={editLoading}
          inputs={inputs}
          totalInputCount={7}
          verifyLoaders={addAdminLoader}
          disableAll={disableAll}
          onInputChange={handleInputValues}
          inputValues={addAdminDetails}
          handleVerify={handleVerify}
          felidError={felidError}
          errors={errors}
          handleSubmitOTP={handleSubmitOTP}
          isDisabledField={id ? ['email_address'] : []}
          isOpenOtpModel={isOpenOtpModel}
          setIsOpenOtpModel={setIsOpenOtpModel}
          RequiredPostalCode={true}
          mapping={true}
        />
        <S3ImageUpload
          heading="Upload SOP (Standard Operating Procedure)"
          disabled={disableAll || editLoading}
          upload_id={"sop_file"}
          UploadPath={"uploads/admins/sop"}
          handleUpload={handleInputValues}
          uploadedFile={sop_file}
        />
        <AccessPrivilege
          handelCheckBox={handelCheckBox}
          editLoading={editLoading}
          checkedArray={accessPrivilege}
          handelAllAccessPrivilege={handelAllAccessPrivilege}
          isSupperAdmin={is_super_admin}
          error={errors?.access_privilege ? errors?.access_privilege : ""}
        />
        <CheckBoxWithTitle
          title={"Wallet Access"}
          CheckBoxArray={["eTop Up", "Digital wallet"]}
          checkedArray={wallet_access}
          handelCheckBox={handelCheckBox}
          disabledCheckBox={editLoading ? ["eTop Up", "Digital wallet"] : ["Digital wallet"]}
        />
      </AddModel>
      <AddBottomButton
        buttonName={`${!id ? 'Add' : 'Update'} Admin`}
        buttonClass="w-[120px]"
        buttonWidth={`${!id ? 'w-[140px]' : 'w-[170px]'}`}
        onClick={handleSubmit}
        disabled={disableAll || (id ? (editLoading || hasUnverifiedSecondaryPhone || (!hasSecondaryPhoneChanges && deepEqual(
          { ...editData, access_privileges: accessPrivilegeEdit, wallet_access: wallet_access_edit, secondary_phone_numbers: editData.secondary_phone_numbers || [] },
          { ...addAdminDetails, access_privileges: accessPrivilege, wallet_access: wallet_access, secondary_phone_numbers: currentSecondaryPhones }
        ))) : false)}
        loading={add_loading}
        testID={"add_admin_page"}
      />
    </div>
  );
}
  
